import React, { useState } from "react";
import IconTooltip from "./IconTooltip";
import I18n from 'i18n.js.erb'



const BlockchainPublicKeyCopyButton = ({ publicKey }) => {

  const [ clicked, setClicked ] = useState(false)

  const handleClick = () => {
    setClicked(true)
    navigator.clipboard.writeText(publicKey)
  }

  const handleMouseLeave = () => {
    setTimeout(() => {
      setClicked(false)
    }, 150)
  }

  return <IconTooltip
      tooltipPosition={'top'}
      tooltipTitle={''}
      tooltipContent={ I18n.t('js.profilePage.copy') }
      tooltipContent2={ clicked && I18n.t('js.profilePage.copied') }
      iconColor={'#049FE3'}
      customComponentToRender={
        <React.Fragment>
          <div className="d-flex justify-content-center align-items-center text-center p-2 br-50px ml-2 mb-1 cursor-pointer bg-aig-gradient"
               onClick={handleClick}
               onMouseLeave={handleMouseLeave}
          >
            <img src={window.location.origin + `/images/icons/white/copy.svg`}
                 alt=""
            />
          </div>
        </React.Fragment>
      }
    />
}

export default BlockchainPublicKeyCopyButton;